import config from 'config';

const LOAD = 'horse-racing/race/LOAD';
const LOAD_SUCCESS = 'horse-racing/race/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/race/LOAD_FAIL';

const initialState = {
  loaded: false,
  race : {
    race_summary:{
      meeting_summary_reference:{id:null,external_reference:[]},
      race_summary_reference:{id:null,external_reference:[]},
      name:null,
      course_name:null,
      course_surface:{
        surface:null,
        translation:null
      },
      age:null,
      race_class:null,
      distance:null,
      date:null,
      time:null,
      off_time:null,
      winning_time:null,
      ride_count:null,
      race_stage:null,
      has_video:null,
      going:null,
      has_handicap:false
    },
    previous_winner:null,
    prizes:{
      prize:[]
    },
    verdict:null,
    betting_forecast: null,
    rides:[],
    number_of_placed_rides:null,
    videos:[],
    tote_win:null,
    place_win:null,
    exacta_win:null,
    trifecta:null,
    superfecta:null,
    tricast:null,
    swingers:null,
    straight_forecast:null,
    place_pot:{pot:null, pool:null, winStakes:null},
    quad_pot:{pot:null, pool:null, winStakes:null}
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS: {
      // TODO: This is in relation to SPL-2289. The array should be fully parsed by this fix.
      const result = action.result[0] || null;
      return {
        ...state,
        loading: false,
        loaded: true,
        race: result,
        error: null
      };
    }
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isLoading(globalState, raceId) {
  return globalState.horseRacing.race && globalState.horseRacing.race.loading
      && globalState.horseRacing.race.race
      && globalState.horseRacing.race.race.race_summary
      && globalState.horseRacing.race.race.race_summary.race_summary_reference
      && globalState.horseRacing.race.race.race_summary.race_summary_reference.id == raceId;
}

export function load(id) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(`${config.api.horseRacing.loadRace}/${id}`).then(race => [race])
  };
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/race.js